import React from 'react'
import Guidelines from './Guidelines'
import QuestionRubricCollapse from '../QuestionRubricCollapse'

const GuidelinesSection = ({ question, answers }) => {
    const questionRubrics = question.questionRubrics || []

    if (questionRubrics.length > 1) {
        return <QuestionRubricCollapse question={question} answers={answers} ContentComponent={Guidelines} />
    }

    return <Guidelines question={question} questionRubric={questionRubrics[0]} />
}

export default GuidelinesSection
